import { FC, useContext, useMemo } from 'react';

import { StepTwoFormContext } from '../../../StepTwo/contexts';
import { StepThreeFormContext } from '../../contexts';

import {
  GenericDataFormContext,
  GroupedCoverageCardsList,
  QuotationInfoContext
} from '../../../../../shared';
import { ContentSection } from '../../../../../../../../../shared/components';
import {
  groupCardsByCommonSection,
  GroupedCoveragesCardsResult,
} from '../../../../../utils';

interface CoveragesPersonalEffectsProps {
  tabKey: number;
}

export const CoveragesPersonalEffects: FC<CoveragesPersonalEffectsProps> = ({
  tabKey,
}) => {
  const { stepThreePersonalEffectsQuotationForm } = useContext(StepThreeFormContext);

  const { stepTwoForm } = useContext(StepTwoFormContext);

  const { quotationInfo } = useContext( QuotationInfoContext );

  const { allCoveragesPerPlan, getRelationWithOtherCoverage } = useContext(GenericDataFormContext);

  const planSelected = stepTwoForm?.getFieldValue(`plan-tab-${tabKey}`);

  const allCoveragesByTab = useMemo(
    () =>
      allCoveragesPerPlan.find((el) => (el.plan as string) === planSelected)
        ?.coverages,
    [allCoveragesPerPlan, planSelected]
  );

  const groupedCoveragesCardsResult: GroupedCoveragesCardsResult =
    useMemo(() => {
      return allCoveragesByTab
        ? groupCardsByCommonSection(allCoveragesByTab, 'codigoFamilia')
        : {};
    }, [allCoveragesByTab]);

  return (
    <ContentSection level='h3' title='Coberturas' hasCard={false}>
      {Object.keys(groupedCoveragesCardsResult).map((key, index) => {
        if (!groupedCoveragesCardsResult[key].title) {
          return (
            <GroupedCoverageCardsList
              key={key}
              quotationInfo={quotationInfo}
              groupedCoverageKey={key}
              className={index !== 0 ? 'mt-2' : 'grouped-coverages-first-title'}
              groupedCoveragesCardsResult={groupedCoveragesCardsResult}
              tabKeyForm={`personal-effects-tab-${tabKey}`}
              usedFormToCoverageCard={stepThreePersonalEffectsQuotationForm}
              allCoveragesByTabList={allCoveragesByTab ?? []}
              getRelationWithOtherCoverage={getRelationWithOtherCoverage}
            />
          );
        }
      })}

      {Object.keys(groupedCoveragesCardsResult).map((key, index) => {
        if (groupedCoveragesCardsResult[key].title) {
          return (
            <GroupedCoverageCardsList
              key={key}
              quotationInfo={quotationInfo}
              groupedCoverageKey={key}
              className={index !== 0 ? 'mt-2' : 'grouped-coverages-first-title'}
              groupedCoveragesCardsResult={groupedCoveragesCardsResult}
              tabKeyForm={`personal-effects-tab-${tabKey}`}
              usedFormToCoverageCard={stepThreePersonalEffectsQuotationForm}
              allCoveragesByTabList={allCoveragesByTab ?? []}
              getRelationWithOtherCoverage={getRelationWithOtherCoverage}
            />
          );
        }
      })}
    </ContentSection>
  );
};
